import { useEffect } from 'react'
import UAccordionHeader from './UAccordionHeader'

import type { VFC } from 'react'
import type { CommonStoreState } from '../../store'

type UDeviceOnboardingStepsProps = {
  title: string
  subtitle: string
  state: CommonStoreState
  setDisable: (disable: boolean) => void
}

const UDeviceOnboardingSteps: VFC<UDeviceOnboardingStepsProps> = (props) => {
  const { title, state, setDisable } = props

  useEffect(() => {
    if (state.supportAccountId && (state.tsg || state.tsgs[0].children?.length === 0)) {
      setDisable(false)
    }
    else {
      setDisable(true)
    }
  }, [setDisable, state.supportAccountId, state.tsg, state.tsgs])

  return (
    <div>
      <UAccordionHeader title={title} />
    </div>
  )
}

export default UDeviceOnboardingSteps
